// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img-w-full img{width:100%}.image-text-horizontal-grid ol{list-style-type:decimal;padding-left:16px}.image-text-horizontal-grid-columns div{flex-grow:1}.image-text-horizontal-grid-columns .mr-text-component, .image-text-horizontal-grid .headline{padding:0}.image-text-horizontal-grid:not(.image-50) .img-wrapper img{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
